import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { chevronForwardOutline } from "ionicons/icons";
import { useRef } from "react";
import { QRCodeList } from "../components/QRCodeList";

const History = () => {
  const pageRef = useRef();

  return (
    <IonPage ref={pageRef}>
      <IonHeader className="ion-no-border">
        <IonToolbar className="background-color">
          <IonTitle>History</IonTitle>
          <IonButtons slot="end">
            <IonButton
              slot="end"
              routerLink="/checkout"
              routerDirection="forward"
            >
              <IonIcon icon={chevronForwardOutline} color="primary" />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <QRCodeList pageRef={pageRef} />
      </IonContent>
    </IonPage>
  );
};

export default History;
